import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function AcceptInvitation() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    const API_BASE_URL_AUTH = process.env.REACT_APP_API_BASE_URL_AUTH;

    if (!token) return;

    fetch(`${API_BASE_URL_AUTH}/Employees/accept-invitation?token=${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    })
      .then(async (res) => {
        if (!res.ok) throw new Error("Invitation verification failed");
        const data = await res.json();
         

        navigate("/login");
      })
      .catch((err) => {
        console.error(err);
        alert("Invalid or expired invitation link");
      });
  }, [location, navigate]);

  return <p>Verifying your invitation...</p>;
}

export default AcceptInvitation;
